// packages/shared/utils/tokenStore.js

let _token = null;

export const setGlobalToken = (token) => {
  _token = token;
};

export const getGlobalToken = () => _token;

export const initGlobalTokenFromStorage = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    const stored = window.localStorage.getItem('token');
    if (stored) {
      _token = stored;
    }
  }
};
